import { useEffect, useRef, useState } from 'react';

// Parity: BaseListScreen.kt:180-189 — 500ms debounce, skip the first emission (drop(1)).
export function useDebouncedValue<T>(value: T, delay = 500): T {
  const [debounced, setDebounced] = useState(value);
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    } // drop(1)
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
